import {
  getClient,
  type Client,
  type Components,
  type EntityResponseWithHits,
  type EntityResponseGroupedWithHits,
  type EntitySearchParams,
  type EntitySlug
} from '@epilot/customer-portal-client'

import AuthUtils from 'utils/AuthUtils'
import { getCurrentLanguage } from 'utils/LanguageUtils'

import { getConfig } from '../EnvConfig'

let customerApiClient: Client | null = null

export const getCustomerApiClient = () => {
  if (customerApiClient) return customerApiClient

  customerApiClient = getClient()

  customerApiClient.defaults.baseURL = getConfig().CUSTOMER_PORTAL_API_URL

  if (customerApiClient.interceptors.request['handlers'].length > 3) {
    console.error(
      'Sanity check: This client already has more than 3 request interceptors, refusing to add more!',
      {
        baseURL: customerApiClient.defaults.baseURL,
        interceptors: customerApiClient.interceptors
      }
    )
  } else {
    customerApiClient.interceptors.request.use(async (request) => {
      const token: string = await AuthUtils.getAccessToken()

      const isNotPublicRequest = !request.url.includes('/public')

      if (token && isNotPublicRequest) {
        request.headers['authorization'] = `Bearer ${token}`
      }

      request.headers['Accept-Language'] = getCurrentLanguage()

      return request
    })
  }

  return customerApiClient
}

export const PORTAL_TYPES = {
  endCustomerPortal: 'END_CUSTOMER_PORTAL',
  installerPortal: 'INSTALLER_PORTAL'
}

export type {
  Components,
  EntityResponseWithHits,
  EntityResponseGroupedWithHits,
  EntitySearchParams,
  EntitySlug
}

export type Entities = EntityResponseWithHits['results']
export type EntitiesHits = EntityResponseWithHits['hits']
export type EntitiesPagination = EntityResponseWithHits['pagination']
export type EntitiesPaginationFrom =
  EntityResponseWithHits['pagination']['from']
export type EntitiesGrouped = EntityResponseGroupedWithHits['groups']
export type EntitiesGroupedHits = EntityResponseGroupedWithHits['hits']
export type EntitiesGroupedPagination =
  EntityResponseGroupedWithHits['groups_pagination']
export type EntitiesGroupedAfterKey =
  EntityResponseGroupedWithHits['groups_pagination']['after_key']
